<!--
  组件说明：考试列表组件
  调用示范：
  <ksList :value.sync="ksObj" @change="页面数据加载方法"></ksList>
-->
<template>
  <el-select v-model="myKsid" filterable placeholder="请选择考试" @change="returnExam">
    <el-option
      v-for="item in data"
      :key="item.ksid"
      :label="item.ksmc"
      :value="item.ksid">
    </el-option>
  </el-select>
</template>
<script>
// import { getList } from '@/api/exam'
import * as examListn from '@/api/report'
export default {
  data (props) {
    return {
      data: [],
      myKsid: props.ksid || null
    }
  },
  props: {
    ksid: {
      type: Number
    }
  },
  methods: {
    returnExam (ksid) {
      const examObj = this.data.find(item => item.ksid === ksid)
      this.$emit('update:value', examObj) // 将考试对象返回到父页面
      this.$emit('change') // 执行父页面方法
    }
  },
  async mounted () {
    examListn.getKsnameList(null).then(res => {
      this.$http.callback(res, () => {
        this.data = res.data
        if (this.myKsid != null) {
          this.returnExam(this.myKsid)
        }
      })
    })
  }
}
</script>
